import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoading: false
};

const loaderModel = createSlice({
    name: 'loader',
    initialState,
    reducers: {
        startLoading: (state, action) => {
            state.isLoading = true;
        },
        stopLoading: (state,action) => {
            state.isLoading = false;
        }
    }
})

export { loaderModel };
export default loaderModel.reducer;